// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__34ZMA","box":"WorkspacesBox_box__3hgTw","node":"WorkspacesBox_node__1Mci9"};